import React, { useRef } from "react";
import L from "leaflet";
import domtoimage from "dom-to-image";
import { useAsyncEffect } from "@kido/hooks";
import { useRecoilState } from "recoil";
import { filtersSelector } from "../../store/selectors";

const Map = ({ setURL }) => {
  const [filters] = useRecoilState(filtersSelector);
  const mapens = useRef(null);
  const tile = useRef(null);
  const marker = useRef(null);
  const size = useRef({
    width: 320,
    height: 180
  });
  const zoom = useRef({
    PRO: 7,
    COM: 11,
    MUN: 12,
    DIS: 13
  });

  useAsyncEffect(async () => {
    const mapDOM = document.getElementById("map");
    const position = [41.390205, 2.154007];

    const map = L.map("map", {
      attributionControl: false,
      zoomControl: false,
      fadeAnimation: false,
      zoomAnimation: false
    }).setView(position, 12);

    marker.current = L.marker(position).addTo(map);
    const tileLayer = L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(map);
    await new Promise((resolve) => tileLayer.on("load", () => resolve()));
    const url = await domtoimage.toPng(mapDOM, { width: size.current.width, height: size.current.height });

    setURL(url);
    tile.current = tileLayer;
    mapens.current = map;
  }, []);

  useAsyncEffect(async () => {
    if (filters.position.length) {
      if (marker.current) {
        marker.current.remove();
        marker.current = null;
      }

      if (filters.host_level !== "PRO" && filters.host_level !== "COM") {
        marker.current = L.marker(filters.position).addTo(mapens.current);
      }

      const mapDOM = document.getElementById("map");
      mapens.current.setView(filters.position, zoom.current[filters.host_level]);
      await new Promise((resolve) => tile.current.on("load", () => resolve()));
      const url = await domtoimage.toPng(mapDOM, { width: size.current.width, height: size.current.height });

      setURL(url);
    }
  }, [filters.position]);

  return (
    <div id="mapWrapper">
      <div id="map" style={{ width: "300px", height: "220px" }}></div>
    </div>
  );
};

export default Map;
